import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { MaskLines } from "@/components/Reveal";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("The two passwords don't match.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="reset-password-page" className="mx-auto flex min-h-screen max-w-md flex-col justify-center px-5 pb-20">
      {done ? (
        <>
          <p className="eyebrow">All set</p>
          <h1 className="mt-4 font-display text-6xl font-light leading-none"><MaskLines lines={["Password", "updated."]} lineClass="last:italic" /></h1>
          <p className="mt-6 text-stone">Your password has been changed. Sign in with your new password.</p>
          <Link to="/login" data-testid="reset-login-link" className="mt-8 w-fit rounded-full bg-ink px-7 py-4 text-sm text-bone">Back to sign in</Link>
        </>
      ) : !token ? (
        <>
          <p className="eyebrow">Reset link missing</p>
          <h1 className="mt-4 font-display text-5xl font-light leading-tight">This page needs a <em>reset link.</em></h1>
          <p className="mt-6 text-stone">Start again from the "Forgot password?" link on the sign-in page.</p>
          <Link to="/login" className="mt-8 w-fit rounded-full bg-ink px-7 py-4 text-sm text-bone">Back to sign in</Link>
        </>
      ) : (
        <>
          <p className="eyebrow">Choose a new password</p>
          <h1 className="mt-4 font-display text-6xl font-light leading-none">New <em>password.</em></h1>
          <form onSubmit={submit} className="mt-10 space-y-6">
            <label className="block" htmlFor="np">
              <span className="eyebrow">New password (6+ characters)</span>
              <input id="np" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" className="mt-2 w-full border-b border-ink/40 bg-transparent py-3 text-lg outline-none focus:border-ink" />
            </label>
            <label className="block" htmlFor="np2">
              <span className="eyebrow">Confirm new password</span>
              <input id="np2" type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm-input" className="mt-2 w-full border-b border-ink/40 bg-transparent py-3 text-lg outline-none focus:border-ink" />
            </label>
            {error && <p data-testid="reset-error" className="text-sm text-signal">{error}</p>}
            <button type="submit" disabled={loading} data-testid="reset-submit-button" className="w-full rounded-full bg-ink py-4 text-sm text-bone transition-colors duration-300 hover:bg-signal disabled:opacity-60">
              {loading ? "Saving…" : "Update password"}
            </button>
          </form>
        </>
      )}
    </main>
  );
}
